import { render, staticRenderFns } from "./SocialIdentityPanel.vue?vue&type=template&id=1a43cc0a&"
import script from "./SocialIdentityPanel.vue?vue&type=script&lang=js&"
export * from "./SocialIdentityPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports